import { gql } from '@apollo/client';

export const CREATE_TAG_MUTATION = gql`
    mutation createTag($input: CreateTagInput!) {
        result: createTag(input: $input) {
            id
            name
            slug
            metadata
            createdAt
            updatedAt
        }
    } 
`;